import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["sendButton", "cancelButton", "backButton", "chatTextarea"]
  
  connect() {
    console.log("Stop button controller connected")

    this.sendButton = this.hasSendButtonTarget ?
      this.sendButtonTarget :
      document.getElementById("send-button")

    this.cancelButton = this.hasCancelButtonTarget ?
      this.cancelButtonTarget :
      document.getElementById("cancel-button")

    this.backButton = this.hasBackButtonTarget ?
      this.backButtonTarget :
      document.getElementById("back-button")

    // Get reference to chat textarea
    this.chatTextarea = this.hasChatTextareaTarget ?
      this.chatTextareaTarget :
      document.getElementById("chatPromptField")

    if (!this.sendButton || !this.cancelButton || !this.backButton) {
      console.error("Stop button controller: Could not find all required buttons")
      return
    }

    if (!this.chatTextarea) {
      console.error("Stop button controller: Could not find chat textarea")
      return
    }

    this.updateButtonVisibility()

    setTimeout(() => {
      this.observeAllStatuses()
    }, 100)
  }

  disconnect() {
    console.log("Stop button controller disconnecting")
    if (this.observer) {
      this.observer.disconnect()
    }
    // Re-enable textarea on disconnect to prevent it staying disabled
    this.enableChatTextarea()
  }

  observeAllStatuses() {
    if (this.observer) {
      this.observer.disconnect()
    }

    this.observer = new MutationObserver(() => {
      clearTimeout(this.updateTimeout)
      this.updateTimeout = setTimeout(() => {
        this.updateButtonVisibility()
      }, 50)
    })

    this.observeCurrentStatuses()

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributeFilter: ['id']
    })
  }

  observeCurrentStatuses() {
    const statusElements = document.querySelectorAll("[id^='msg-status-']")
    console.log(`Found ${statusElements.length} status elements`)

    statusElements.forEach(statusElement => {
      this.observer.observe(statusElement, {
        childList: true,
        subtree: true,
        characterData: true
      })
    })
  }

  updateButtonVisibility() {
    const statusElements = document.querySelectorAll("[id^='msg-status-']")
  
    const anyStreaming = Array.from(statusElements)
      .some(el => {
        const text = el.textContent.trim().toLowerCase()
        return text === "streaming" || text.includes("streaming")
      })
  
    const anyPending = Array.from(statusElements)
      .some(el => {
        const text = el.textContent.trim().toLowerCase()
        return text === "pending" || text.includes("pending")
      })
  
    console.log(`Streaming: ${anyStreaming}, Pending: ${anyPending}`)
  
    if (this.sendButton && this.cancelButton && this.backButton) {
      if (anyStreaming) {
        this.sendButton.classList.add("d-none")
        this.backButton.classList.add("d-none")
        this.cancelButton.classList.remove("d-none")
        this.disableChatTextarea()
      } else if (anyPending) {
        this.sendButton.classList.add("d-none")
        this.cancelButton.classList.add("d-none")
        this.backButton.classList.remove("d-none")
        this.disableChatTextarea()
      } else {
        this.cancelButton.classList.add("d-none")
        this.backButton.classList.add("d-none")
        this.sendButton.classList.remove("d-none")
        this.enableChatTextarea()
      }
    }
  }

  disableChatTextarea() {
    if (this.chatTextarea) {
      this.chatTextarea.disabled = true
      this.chatTextarea.style.opacity = "0.6"
      this.chatTextarea.style.cursor = "not-allowed"
      console.log("Chat textarea disabled")
    }
  }

  enableChatTextarea() {
    if (this.chatTextarea) {
      this.chatTextarea.disabled = false
      this.chatTextarea.style.opacity = "1"
      this.chatTextarea.style.cursor = "text"
      console.log("Chat textarea enabled")
    }
  }

  refresh() {
    this.updateButtonVisibility()
  }
}